if (!customElements.get("products-set")) {
	/**
	 * Custom HTML element for managing a set of products, handling variant selection,
	 * set completeness, and adding the set to the cart.
	 *
	 * @class ProductsSet
	 * @extends HTMLElement
	 * @property {boolean} DEV - Flag for development logging.
	 * @property {Object} set - Stores selected product variants by product ID.
	 */
	class ProductsSet extends HTMLElement {
		constructor() {
			super();
			this.DEV = true;

			this.initSet();
			this.checkSet();
			this.#log("SET: ", this.set);

			/* Event listener on add to cart button */
			this.querySelector("[data-js-add-set-to-cart]").addEventListener("click", (e) => {
					let items = [];
					Object.keys(this.set).map((key) => {
						if (this.set[key] !== null) {
							items.push({
								id: this.set[key],
								quantity: 1,
							});
						}
					});

					if (items.length > 0) {
						const submitButton = this.querySelector(
							"[data-js-add-set-to-cart]"
						);
						submitButton.classList.add("working");

						window.handleAddToCart(
							JSON.stringify({items: items}),
							items.length,
							{
								"Content-Type": "application/json",
							},
							() => {
								submitButton.classList.remove("working");
								this.returnToDefaultState();
							}
						);
					}
				}
			);
		}

		/**
		 * Initializes the set object and attaches event listeners to product variants.
		 */
		initSet() {
			this.set = {};

			this.querySelectorAll("product-variants").forEach((elm) => {
				if (
					!elm.hasAttribute("data-has-variants") &&
					!elm.hasAttribute("data-unavailable")
				) {
					this.set[elm.dataset.id] =
						elm.parentNode.querySelector('input[name="id"]').value;
				} else {
					this.set[elm.dataset.id] = null;
					elm.addEventListener("VARIANT_CHANGE", (e) => {
						let variant = e.target.currentVariant;
						if (variant) {
							this.set[elm.dataset.id] =
							elm.parentNode.querySelector('input[name="id"]').value;
							elm.closest("[data-js-product-item]").classList.add("selected");
							/// elm.closest('toggle-tab').querySelector('[data-js-product-variant-title]').textContent = variant.title;
						} else {
							this.set[elm.dataset.id] = null;
							///elm.closest('toggle-tab').querySelector('[data-js-product-variant-title]').textContent = '';
						}
						this.checkSet();
					});
				}
			});
		}

		/**
		 * Checks if the set is complete (all products selected) and updates UI accordingly.
		 * @returns {boolean} True if set is complete, false otherwise.
		 */
		checkSet() {
			let setFull = true;

			Object.keys(this.set).map((key) => {
				if (this.set[key] === null) {
					setFull = false;
				}
			});

			if (setFull && this.classList.contains("products-set--empty")) {
				this.classList.remove("products-set--empty");
				this.querySelector("[data-js-add-set-to-cart-text]").textContent =
					KROWN.settings.locales.sets_add_to_cart;
			} else if (!setFull && !this.classList.contains("products-set--empty")) {
				this.classList.add("products-set--empty");
			}
			return setFull;
		}

		/**
		 * Returns the UI and internal state to the default state after adding the set to cart.
		 */
		returnToDefaultState() {
			this.querySelectorAll("product-variants").forEach((elm) => {
				elm.querySelectorAll("input").forEach((input) => {
					input.checked = false;
				});
				elm.querySelectorAll("select").forEach((select) => {
					select.selectedIndex = 0;
				});
				if (elm.hasAttribute("data-has-variants") || elm.hasAttribute("data-unavailable")) {
					elm.currentVariant = undefined;
					elm.parentNode
						.querySelector("[data-js-product-add-to-cart]")
						.classList.add("disabled");
				}
			});
			this.querySelectorAll("[data-js-product-item]").forEach((elm) => {
				if (!elm.hasAttribute("data-js-default-variant")){
					elm.classList.remove("selected");
				}
			});
			this.initSet();
			this.checkSet();
			this.querySelector("[data-js-add-set-to-cart-text]").textContent =
				KROWN.settings.locales.sets_choose_products;
		}

		/**
		 * Logs messages to the console if DEV mode is enabled.
		 */
		#log() {
			if (this.DEV) console.log(this.constructor.name, ...arguments);
		}
	}

	customElements.define("products-set", ProductsSet);
}
